var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name)?_c('div',{staticClass:"avatar",style:({ backgroundImage: ("url(" + _vm.avatarPath + ")") })},[_vm._v(" "+_vm._s(!_vm.avatarPath ? _vm.initials : null)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }